import React, { useState, useEffect } from "react";
import Profile from "../../../../Assets/images/avatar.png";
import { toast } from "react-toastify";
import Handler from "../../../../Helpers/Handler";
import { useAuth } from "../../../../Contexts/AuthenticateProvider";

// Ported from the uploaded reference ProfileStage.js - photo/name/gender edit,
// design kept as-is. Phone is dropped from the submitted payload and shown
// read-only: ClientValidation.profileUpdate never accepts a phone field (the
// registration phone is immutable), and photo is optional here (the backend
// keeps the existing photo when none is uploaded) rather than mandatory like
// on first registration. Wired to PATCH /staff/client/associate/profile/:Id
// and gated by associate.edit.
const ProfileStage = ({ associateDetails, onVerified }) => {
    const [formDataState, setFormDataState] = useState({});
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const { hasPermission } = useAuth();
    const canSubmit = hasPermission("associate.edit");

    useEffect(() => {
        setFormDataState(associateDetails || {});
        setPreview(associateDetails?.photo || null);
    }, [associateDetails]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormDataState((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setFormDataState((prev) => ({ ...prev, photoFile: file }));
        }
    };

    const validateForm = () => {
        const { firstName, lastName, gender } = formDataState;
        if (!firstName || !lastName || !gender) {
            toast.error("Please fill all required fields");
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (!canSubmit) {
            toast.error("You don't have permission to edit this associate");
            return;
        }
        if (!validateForm()) return;
        setLoading(true);
        const formData = new FormData();
        formData.append("firstName", formDataState?.firstName);
        formData.append("lastName", formDataState?.lastName);
        formData.append("gender", formDataState?.gender);
        if (formDataState?.photoFile) formData.append("photo", formDataState.photoFile);
        const response = await Handler({ method: "patch", url: `/staff/client/associate/profile/${associateDetails?.associateId}`, data: formData, formdata: true });
        if (response?.success) {
            toast.success(response?.data?.message || "Profile Updated Successfully");
            setTimeout(() => { setLoading(false); onVerified?.(); }, 1200);
        } else {
            setLoading(false);
            toast.error(response?.data?.message || "Something went wrong");
        }
    };

    return (
        <>
            {!canSubmit ? (
                <div className="alert alert-warning small mb-3">
                    You don't have permission to edit this associate's profile.
                </div>
            ) : null}
            <div className="row">
                <div className="col-12 text-center mb-4">
                    <div className="position-relative d-inline-block">
                        <img src={preview || Profile} alt="Preview" className="rounded-circle border" width="130" height="130" style={{ objectFit: "cover" }} />
                        <input type="file" accept="image/*" data-crop-aspect="1" disabled={loading || !canSubmit} className="position-absolute top-0 start-0 w-100 h-100 cursor-pointer opacity-0" onChange={handleImageChange} />
                    </div>
                    <div className="mt-2 small text-muted">Upload Profile Photo</div>
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">First Name</label>
                    <input type="text" autoComplete="off" name="firstName" value={formDataState?.firstName || ""} onChange={handleChange} disabled={loading || !canSubmit} className="form-control text-capitalize" />
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">Last Name</label>
                    <input type="text" autoComplete="off" name="lastName" disabled={loading || !canSubmit} value={formDataState?.lastName || ""} onChange={handleChange} className="form-control text-capitalize" />
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">Phone</label>
                    <input type="text" autoComplete="off" value={formDataState?.phone || ""} className="form-control" disabled />
                </div>
                <div className="col-md-6 mb-3">
                    <label className="form-label">Gender</label>
                    <select name="gender" value={formDataState?.gender || ""} onChange={handleChange} disabled={loading || !canSubmit} className="form-select">
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="others">Others</option>
                    </select>
                </div>
            </div>
            <div className="text-center mt-4">
                <button className="btn btn-primary px-4" onClick={handleSubmit} disabled={loading || !canSubmit}>{loading ? "Updating..." : "Update Profile"}</button>
            </div>
        </>
    );
};

export default ProfileStage;
